export const songPath = {
  letMeLoveYou: "/songs/Let_Me_Love_You.mp3",
  deva_deva: "/songs/DEVA_DEVA.mp3",
  Yesterday: "/songs/Yesterday.mp3",
  OnMyWay: "/songs/OnMyWay.mp3",
  DontYouHoldMe: "/songs/DontYouHoldMe.mp3",
  LalaLiLala: "/songs/LalaLiLala.mp3",
  LightTheSky: "/songs/LightTheSky.mp3",
  TusBesos: "/songs/TusBesos.mp3",
  UhhNaiNa: "/songs/UhhNaiNa.mp3",
  LetMeDownSlowly: "/songs/LetMeDownSlowly.mp3",
};
